// extracted by mini-css-extract-plugin
module.exports = {"selectSpan":"src-pages-Banner-TemplateLinks-module__selectSpan--3J8h4"};